import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme } from '../context/ThemeContext'
import { useTranslation } from 'react-i18next'

export function ThemeToggle() {
    const { theme, setTheme } = useTheme()
    const { t } = useTranslation()

    return (
        <div className="flex bg-gray-100 dark:bg-gray-800 rounded-full p-1 border border-gray-200 dark:border-gray-700 shadow-sm transition-[border-color,box-shadow] duration-200" role="radiogroup" aria-label={t('theme.label', 'Theme')}>
            <button
                onClick={() => setTheme('light')}
                className={`p-1.5 rounded-full transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 ${theme === 'light' ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-md transform scale-110' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
                aria-label={t('theme.light', 'Light mode')}
                aria-pressed={theme === 'light'}
            >
                <Sun size={16} aria-hidden="true" />
            </button>
            <button
                onClick={() => setTheme('dark')}
                className={`p-1.5 rounded-full transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 ${theme === 'dark' ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-md transform scale-110' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
                aria-label={t('theme.dark', 'Dark mode')}
                aria-pressed={theme === 'dark'}
            >
                <Moon size={16} aria-hidden="true" />
            </button>
            <button
                onClick={() => setTheme('system')}
                className={`p-1.5 rounded-full transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 ${theme === 'system' ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-md transform scale-110' : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'}`}
                aria-label={t('theme.system', 'System theme')}
                aria-pressed={theme === 'system'}
            >
                <Monitor size={16} aria-hidden="true" />
            </button>
        </div>
    )
}
